import React from "react";

import Button from "../Button";

import "./Buttons.scss";

const Buttons = ({
  gameStarted,
  completed,
  selected,
  onStartGame,
  onDeselect,
  onSubmit,
  setShowTerms,
  hasTerms,
  termsType,
  buttonColor,
  textColor,
}) => {
  const buttonStyle = {
    backgroundColor: buttonColor || undefined,
    color: "white",
  };

  if (completed.length >= 4) {
    return null;
  }
  return !gameStarted ? (
    <div
      className="Buttons"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <Button onClick={onStartGame} style={buttonStyle}>
        Start
      </Button>
      {/* Only show terms button if game has terms content */}
      {hasTerms && (
        <div className="terms-container">
          {termsType === "url" && typeof hasTerms === "string" ? (
            <div className="terms">
              <a
                href={hasTerms}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: textColor, fontSize: "14px" }}
              >
                Terms & Conditions
              </a>
            </div>
          ) : (
            <div className="terms">
              <div
                onClick={() => setShowTerms(true)}
                style={{
                  color: textColor,
                  fontSize: "14px",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Terms & Conditions
              </div>
            </div>
          )}
          <span className="terms-text">
            By starting the game, I have read and agree to the terms and
            conditions.
          </span>
        </div>
      )}
    </div>
  ) : (
    <div className="Buttons">
      <Button onClick={onDeselect} style={buttonStyle}>
        Deselect All
      </Button>
      <Button
        onClick={onSubmit}
        disabled={selected.length < 4}
        style={buttonStyle}
      >
        Submit
      </Button>
    </div>
  );
};

export default Buttons;
